import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { toast } from "react-toastify";
// import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { numberWithCommas, makeLinkForQuickbooks, ModuleType, ReportType } from '../../../common/commonServices';
import { Accounts } from '../../../../appRedux/actions/accountAction';
import CircularProgress from "../../../../components/CircularProgress";
import { GetUncategorizeData, LedgerUpdate, UpdateBatchNewAccount, UpdateBatchNeedsBetterDescription, MarkReportReview, GetReportReviewedHistory } from '../../../../appRedux/actions/LedgerAction';
import "react-datepicker/dist/react-datepicker.css";
import CommonComments from './../../../common/Comments';
import TransactionEditRow from '../../../common/TransactionEditRow';
import { toAccountOptions, startSave, handleLedgerResult, handleMemoResult, accountSelectMenuProps } from '../../../common/transactionEdit';
import RSelect from 'react-select';
import "./companyDash.css";
import { MARK_IGNORED_DATA, Revert_Ignored_DATA } from '../../../../appRedux/actions/ReportDetailAction';
import './DataEntryIssues.css';

// Shared transaction edit row (NBD + CPA), Internal Notes / Q&C / CPA columns, Assign NBD, TBR +/- group icons.
const FontTooltip = withStyles(() => ({
    tooltip: {
        fontSize: 12
    },
}))(Tooltip);

// No New Account # column; a row with a New Account leaves this list, so the cell is always empty.
const COLUMN_COUNT = 12;
const EDIT_FLAGS = ['nbd', 'cpa'];

class UnCategorizeTransaction extends Component {

    constructor(props) {
        super(props);
        this.sDateRef = React.createRef();
        this.eDateRef = React.createRef();
        // let eDate = new Date();
        // let sDate = new Date(eDate.getFullYear(), 0, 1);
        // if (eDate.getMonth() <= 2) {
        //     sDate.setFullYear(eDate.getFullYear() - 1, 0, 1);
        //     eDate = new Date(eDate.getFullYear() - 1, 11, 31);
        // }
        // else {
        //     sDate = new Date(eDate.getFullYear(), 0, 1);
        //     eDate = GetLastQuarterEndDate();
        // }

        this.state = {
            lst_GL: [],
            mergelst_GL: [],
            loading: true,
            companyId: 0,
            eDate: new Date(),
            sDate: new Date(2019, 0, 1),
            ColorCode: "#e27b40",
            IsEmbeddedPage: false,
            sortField: "date",
            sortFormat: "D",
            DisplayAccounts: [],
            selectedAccount: { value: 0, label: "Select" },
            SelectALL: false,
            SelectedRecords: [],
            IsIgnoredFilter: false,
            selectedBatchAccountId: { value: 0, label: "Select" },
            ShowHistory: true,
            HistoryData: [],
            accounts: [],
            editIndex1: -1,
            editIndex: -1
        }
    }

    componentDidMount() {
        let user = JSON.parse(localStorage.getItem('userData'));
        this.setState({
            companyId: user.companyId,
            loading: true
        }, () => {
            this.props.GetReportReviewedHistory(user.companyId, ReportType.UnCategorizeTransaction)
            this.GetReportData();
            this.props.Accounts(this.state.companyId);
        });
    }

    handleFocus = (e, selecter) => {
        let control = null;
        if (selecter !== undefined) {
            if (selecter === "sDate") {
                control = this.sDateRef;
                if (control.current != null) {
                    control.current.setFocus();
                }
            }
            else if (selecter === "eDate") {
                control = this.eDateRef;
                if (control.current != null) {
                    control.current.setFocus();
                }
            }
        }
    }
    HandleClose = () => {
        this.setState({ ShowHistory: false });
    }
    LoadComments = (item) => {
        this.setState({ ShowComment: true, CommentReferenceId: item.id });
    }

    CloseComments = () => {
        this.setState({ ShowComment: false });
    }

    UpdateItemCommentCount = (id, clearUnread) => {
        let item = this.state.lst_GL;
        item.forEach(function (records) {

            records.data.forEach(function (details) {
                if (details.id === id) {
                    // clearUnread=true zeros the badge after the comment modal is closed or reviewed
                    if (clearUnread === true) { details.unreviewCommentCount = 0; } else { details.commentCount++ }
                } });
        });

        this.setState({ lst_GL: item });
    }

    GetReportData(IsRefresh = false) {
        let state = this.state;
        let body = {
            "companyID": state.companyId,
            "sortField": state.sortField,
            "sortFormat": state.sortFormat,
            "fromDate": moment(state.sDate).format("MM/DD/YYYY"),
            "toDate": moment(state.eDate).format("MM/DD/YYYY"),
            "needUpdatQBORecords": IsRefresh,
            "isAllIgnoreUnignore": state.IsIgnoredFilter
        };
        this.props.GetUncategorizeData(body);
    }

    componentWillReceiveProps(nextProps) {
        // LEDGER_GET shares state.ledgers with ReportReviewedHistory / CommonUpdate;
        // only apply payloads that carry Uncategorized GL data.
        if (nextProps.ledgers !== undefined && nextProps.ledgers !== this.props.ledgers) {
            const returnObject = nextProps.ledgers.returnObject;
            const uncategorizedGL = returnObject && returnObject.uncategorizedTransactionsGL;
            if (Array.isArray(uncategorizedGL)) {
                let arr = [];
                if (nextProps.ledgers.transactionStatus === 0) {
                    uncategorizedGL.forEach((item) => {
                        if (item && item.data) {
                            arr = [...arr, ...item.data];
                        }
                    });
                    this.setState({ loading: false, mergelst_GL: arr, lst_GL: uncategorizedGL, SelectALL: false, SelectedRecords: [] });
                }
                else {
                    const errMsg = nextProps.ledgers.resultMsg;
                    this.setState({
                        loading: false, mergelst_GL: [], lst_GL: [], SelectALL: false, SelectedRecords: []
                    }, () => { if (errMsg) { toast.error(errMsg); } });
                }
            }
        }

        if (nextProps.ReportReviewdHistory !== undefined && nextProps.ReportReviewdHistory !== this.props.ReportReviewdHistory) {
            if (nextProps.ReportReviewdHistory.transactionStatus === 0) {
                this.setState({ ShowHistory: true, HistoryData: nextProps.ReportReviewdHistory.returnObject });
            }
        }
        if (nextProps.accounts != undefined && nextProps.accounts !== this.props.accounts) {
            this.setState({
                accounts: nextProps.accounts.data || [],
                DisplayAccounts: toAccountOptions(nextProps.accounts.data)
            });
        }

        if (nextProps.LEDGER_UPDATE != undefined && nextProps.LEDGER_UPDATE !== this.props.LEDGER_UPDATE) {
            handleLedgerResult(this, nextProps.LEDGER_UPDATE);
        }

        if (nextProps.BATCH_NBD_UPDATE != undefined && nextProps.BATCH_NBD_UPDATE !== this.props.BATCH_NBD_UPDATE) {
            if (nextProps.BATCH_NBD_UPDATE.transactionStatus === 0) {
                this.setState({
                    loading: true, editIndex1: -1, editIndex: -1, SelectedRecords: [], SelectALL: false
                }, () => {
                    toast.success("Needs Better Description assigned successfully.");
                    this.GetReportData();
                });
            }
            else {
                this.setState({ loading: false }, () => {
                    toast.error(nextProps.BATCH_NBD_UPDATE.resultMsg || "Assign NBD failed. Please try again.");
                });
            }
        }

        if (nextProps.BATCH_LEDGER_UPDATE != undefined && nextProps.BATCH_LEDGER_UPDATE !== this.props.BATCH_LEDGER_UPDATE) {
            if (nextProps.BATCH_LEDGER_UPDATE.transactionStatus === 0) {
                this.setState({
                    loading: true, editIndex1: -1, editIndex: -1, SelectedRecords: [], SelectALL: false, selectedBatchAccountId: { value: 0, label: "Select" }
                }, () => {
                    toast.success("Record updated successfully");
                    this.GetReportData();
                });
            }
            else {
                this.setState({
                    loading: false, SelectedRecords: [], SelectALL: false
                }, () => {
                    toast.error(`${nextProps.BATCH_LEDGER_UPDATE.resultMsg}`);
                });

            }
        }
        if (nextProps.CommonUpdate !== undefined && nextProps.CommonUpdate !== this.props.CommonUpdate) {
            if (nextProps.CommonUpdate.transactionStatus === 0) {
                //   let data = this.state.ReportData;
                //   if (this.state.IsReviewProcessing == false) {
                //     let obj = this.state.editedData;
                //     data.map((item, index) => {
                //       if (item.listID === obj.listID) {
                //         item.vendor1099 = obj.vendor1099
                //       }
                //     })

                //     this.setState({editedData: null, IsReviewProcessing: false, reportData: data }, () => { toast.success("Request Process Successfully");
                //     // this.GetReportData();
                //    });
                //   }
                //   else {
                this.setState({ IsReviewProcessing: false }, () => {
                    toast.success("Reviewed Successfully");
                    this.props.GetReportReviewedHistory(this.state.companyId, ReportType.UnCategorizeTransaction)
                });
                //   }
            }
            else {
                this.setState({ loading: false }, () => {
                    const errMsg = nextProps.CommonUpdate && nextProps.CommonUpdate.resultMsg;
                    if (errMsg) { toast.error(errMsg); }
                });
            }

        }

        // Ignore / Revert results arrive here (UPDATE_DESCRIPTION); memo saves do not (memo stays in LedgerUpdate).
        if (nextProps.UpdateDescription !== this.props.UpdateDescription && nextProps.UpdateDescription && !handleMemoResult(this, nextProps.UpdateDescription)) {
            if (nextProps.UpdateDescription.transactionStatus === 0) {
                this.setState({
                    loading: true, editIndex1: -1, editIndex: -1, SelectALL: false, SelectedRecords: []
                }, () => {
                    toast.success(`${nextProps.UpdateDescription.resultMsg}`);
                    this.GetReportData();
                });
            }
            else {
                this.setState({
                    loading: false,
                }, () => {
                    toast.error(`${nextProps.UpdateDescription.resultMsg}`);
                });
            }
        }
    }

    onRefreshDataClick = () => {
        if (!this.state.loading) {
            this.setState({ loading: true }, () => {
                this.GetReportData(true);
            });
        }
    }

    onMarkReviewd = () => {
        this.setState({
            // IsReviewProcessing: true,
            //  loading: true
            loading: false
        }, () => {
            this.props.MarkReportReview(this.state.companyId, ReportType.UnCategorizeTransaction);
        });
    }
    onRowExpandCollapseClick = (accountIndex) => {
        let dataOfGL = [...this.state.lst_GL];
        dataOfGL[accountIndex] = { ...dataOfGL[accountIndex], isExpand: !dataOfGL[accountIndex].isExpand };
        this.setState({ lst_GL: dataOfGL, editIndex1: -1, editIndex: -1 });
    }

    ApplyDate = () => {
        this.setState({
            loading: true,
        }, () => {
            this.GetReportData();
        });
    }

    onLinkClick = (e, accountIndex, rowIndex, rowData) => {
        e.stopPropagation()
        let origin = makeLinkForQuickbooks();
        window.open(origin + rowData.transactionLink);
    }

    handleDateChange = (e, target) => {

        if (target === "fromDate") {

            this.setState({ sDate: new Date(e) });
        }
        else if (target === "uptoDate") {
            this.setState({ eDate: new Date(e) });
        }
    }

    onRowClick = (accountIndex, rowIndex) => {
        this.setState({ editIndex1: accountIndex, editIndex: rowIndex });
    }

    onRowCancel = () => {
        this.setState({ editIndex1: -1, editIndex: -1 });
    }

    // Memo stays in the LedgerUpdate (no separate QuickBooks call).
    onRowSave = (item, editData) => {
        if (!startSave(this, item, editData, ReportType.UnCategorizeTransaction, { memoToQuickBooks: false })) {
            this.setState({ editIndex1: -1 });
        }
    }

    onSortChange = (fieldName) => {
        if (this.state.sortField === fieldName) {
            let formate = this.state.sortFormat === 'A' ? 'D' : 'A';
            this.setState({ sortFormat: formate, loading: true }, () => {
                this.GetReportData();
            });
        } else {
            this.setState({ sortField: fieldName, sortFormat: 'A', loading: true }, () => {
                this.GetReportData();
            });
        }
    }

    OnApplyIgnored = () => {
        let selectedData = this.state.SelectedRecords;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }

        let body = {
            "ids": selectedData,
            "reportType": ReportType.UnCategorizeTransaction,
            "companyID": this.state.companyId
        }

        this.setState({ loading: true }, () => {
            if (this.state.IsIgnoredFilter) {
                this.props.Revert_Ignored_DATA(body);
            }
            else {
                this.props.MARK_IGNORED_DATA(body);
            }
        });
    }


    onCheckboxClick = (e, item) => {
        e.stopPropagation();


        let existInArray = false;
        let data = this.state.SelectedRecords;
        if (data != null && data.length > 0 && data.indexOf(item.id) > -1) {
            existInArray = true;
        }

        if (e.target.checked) {
            if (!existInArray) {
                data.push(item.id);
            }
        }
        else {
            if (existInArray) {
                data.splice(data.indexOf(item.id), 1);
            }
        }

        let all = (data.length == this.state.mergelst_GL.length) ? true : false;
        this.setState({ SelectedRecords: data, SelectALL: all, editIndex1: -1, editIndex: -1 });

    }

    SelectALL = (e) => {
        if (this.state.mergelst_GL.length > 0) {
            if (e.target.checked) {
                let all = [];
                let data = this.state.mergelst_GL;
                for (let i = 0; i < data.length; i++) {
                    all.push(data[i].id);
                }
                this.setState({ SelectALL: true, SelectedRecords: all });
            }
            else {
                this.setState({ SelectALL: false, SelectedRecords: [] });
            }
        }
    }

    // Same selection as Save/Ignore, no confirm, both filter views.
    OnAssignNBD = () => {
        let selectedData = this.state.SelectedRecords;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }

        let body = {
            "companyID": this.state.companyId,
            "glIds": selectedData
        }

        this.setState({ loading: true }, () => {
            this.props.UpdateBatchNeedsBetterDescription(body);
        });
    }

    HandleIgnored = (event) => {

        this.setState({ IsIgnoredFilter: (event.target.value == "true" ? true : false), loading: true, editIndex1: -1, editIndex: -1 }, () => { this.GetReportData() });
    }

    OnAssignNewAccount = () => {
        let selectedData = this.state.SelectedRecords;
        let selectedBatchAccountId = this.state.selectedBatchAccountId;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }

        if (selectedBatchAccountId.value == null || selectedBatchAccountId.value == 0) {
            toast.error("Please select account");
            return false;
        }

        let body = {
            // "ids": selectedData,
            // "reportType": ReportType.UnCategorizeTransaction,
            // "companyID": this.state.companyId
            "txnId": selectedBatchAccountId.value,
            "glIds": selectedData
        }

        this.setState({ loading: true }, () => {
            this.props.UpdateBatchNewAccount(body);
        });
    }

    handalBatchUpdateAccountDropdown = (e) => {

        if (e.value == null || e.value == 0) {
            // var data = [...this.state.lst_GL];
            // data[accountIndex].data[rowIndex].newAccountID = null;
            // data[accountIndex].data[rowIndex].newAccountName = null;
            this.setState({ selectedBatchAccountId: e });
        }
        else {
            // let obj = this.state.accounts.find(x => x.accountID == e.value);
            // var data = [...this.state.lst_GL];
            // data[accountIndex].data[rowIndex].newAccountID = e.value;
            // data[accountIndex].data[rowIndex].newAccountName = obj.name;
            this.setState({ selectedBatchAccountId: e });
        }
    }
    sortHeader = (field, title, extraClass = '') => (
        <th className={`td-width ${extraClass} ${this.state.sortField === field ? (this.state.sortFormat === 'A' ? "asending" : "desending") : ''}`} onClick={() => this.onSortChange(field)}>
            <p className="table-th-title">{title}</p>
        </th>
    )

    render() {

        let selectedItem = this.state.SelectedRecords;
        return (
            <div className="dashboardPage data-entry-issues-page uncategorized-transactions-page">
                {/* {this.state.ShowHistory && this.state.HistoryData != null && this.state.HistoryData.length > 0 &&
                    <React.Fragment>
                        <Dialog
                            className="comment-Top-align"
                            maxWidth="sm"
                            fullWidth={true}
                            open={true}>
                            <React.Fragment>
                                <div className="Comments modal-header"><span className="log-history-title float-left">Reviewed History </span>
                                    <Button className="jr-btn close-btn float-right" onClick={this.HandleClose}><ClearIcon /></Button>
                                </div>
                                <DialogContent>
                                    {this.state.HistoryData.length == 0 ?
                                        <div className="history-box">
                                            <p className="history-item-text">No History Found</p>
                                        </div>
                                        :
                                        <React.Fragment>
                                            {this.state.HistoryData.map((item, i) => (
                                                <div className="history-box"> */}
                                                    {/* <p className="history-item-text">
                           
                          </p>
                           */}
                                                    {/* <p className="history-date-text"> <strong style={{ color: "black" }}>  Last Reviewed  </strong> By <strong> {item.userName}</strong> <strong> on </strong>{item.stCreatedDate}</p>
                                                </div>
                                            ))}
                                        </React.Fragment>
                                    }
                                </DialogContent>
                            </React.Fragment>
                        </Dialog>
                    </React.Fragment>

                } */}
                {this.state.ShowComment ? <CommonComments
                    CloseComments={this.CloseComments}
                    ColorCode={this.state.ColorCode}
                    ModuleType={ModuleType.GeneralReportType}
                    ReportType={ReportType.UnCategorizeTransaction}
                    CompanyId={this.state.companyId}
                    RecordId={this.state.CommentReferenceId}
                    IsEmbeddedPage={this.state.IsEmbeddedPage}
                    UpdateItemCommentCount={this.UpdateItemCommentCount}
                                SilentRefreshData={() => { if (typeof this.GetReportData === "function") { this.GetReportData(false); } else if (typeof this.GetQuestions === "function") { this.GetQuestions(); } else if (typeof this.getGLData === "function") { this.getGLData(); } }}
                >
                </CommonComments> : ""}
                <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h2 className="mb-3 mb-sm-0">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | Please Review Uncategorized Transactions</h2>
                </div>
                <div className="padding-box app-wrapper">
                    {/* <div className="row">
                        <div className="col-md-3">
                             <div className="select-quater-box">
                                <p className="sub-title">Date Selection</p>
                                <div className="row">
                                    <div className="col-sm-4 col-md-12 ">
                                        <div className="datepicker-box">
                                            <div className="date-box">
                                                <DatePicker
                                                    selected={this.state.sDate}
                                                    onChange={(e) => this.handleDateChange(e, 'fromDate')}
                                                    name="fromDate"
                                                    id="date"
                                                    required={true}
                                                    margin="normal"
                                                    disabledKeyboardNavigation
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={5}
                                                    maxDate={this.state.eDate}
                                                    ref={this.sDateRef}
                                                />
                                                <div className="date-icon" onClick={(e) => this.handleFocus(e, 'sDate')}>
                                                    <i className="zmdi zmdi-calendar-note"></i>
                                                </div>
                                            </div>
                                            <div className="to-box">
                                                <span className="text-center ledgerto-text">To</span>
                                            </div>
                                            <div className="date-box">
                                                <DatePicker
                                                    selected={this.state.eDate}
                                                    onChange={(e) => this.handleDateChange(e, 'uptoDate')}
                                                    name="uptoDate"
                                                    id="date"
                                                    required={true}
                                                    margin="normal"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={5}
                                                    disabledKeyboardNavigation
                                                    minDate={this.state.sDate}
                                                    maxDate={new Date()}
                                                    ref={this.eDateRef}
                                                />
                                                <div className="date-icon" onClick={(e) => this.handleFocus(e, 'eDate')}>
                                                    <i className="zmdi zmdi-calendar-note"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="genera-apply-btn dei-mt-5" >
                                            <Button variant="contained" className="orangeColor jr-btn bg-teal text-white refresh-btn" onClick={(e) => this.ApplyDate()} >apply</Button>

                                        </div>

                                    </div>
                                </div>
                            </div> *
                        </div>
                        <div className="col-md-6">
                        </div>
                        <div className="col-md-3 pt-4">
                            <div className="button-right float-right">
                                <Button variant="contained" className="orangeColor jr-btn bg-teal text-white refresh-btn" onClick={() => this.onRefreshDataClick()}><i className="zmdi zmdi-refresh "></i>Refresh Data</Button>
                            </div>
                        </div>
                    </div> */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="float-right">
                                <Button variant="contained" className="graycolor jr-btn bg-teal text-white refresh-btn" onClick={() => this.onMarkReviewd()}>Mark as Reviewed</Button>
                                <Button variant="contained" className="orangeColor jr-btn bg-teal text-white refresh-btn" onClick={() => this.onRefreshDataClick()}><i className="zmdi zmdi-refresh "></i>Refresh Data</Button>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-12">
                            <div className='d-flex justify-content-end align-items-center'>
                                <div className='show-previously-box'>
                                    <div className="form-group d-flex mb-0">
                                        <h4 className="col-form-label">Show Previously Ignored Transactions:</h4>
                                        <div className="dropdown-input-box">
                                            <select className="dei-filter-select select-box arrow-box" onChange={this.HandleIgnored} value={this.state.IsIgnoredFilter} >
                                                <option value={true}> YES </option>
                                                <option value={false}> NO </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='assign-vendor-box'>
                                    <div className="form-group d-flex mb-0">
                                        <h4 className="col-form-label">New Account:</h4>
                                        <div className='rselect-box'>
                                            <RSelect
                                                name="BatchNewAccountID"
                                                value={this.state.selectedBatchAccountId}
                                                onChange={(e) => this.handalBatchUpdateAccountDropdown(e)}
                                                options={this.state.DisplayAccounts}
                                                placeholder="Select"
                                                {...accountSelectMenuProps()}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className=''>
                                    <Button variant="contained" className=" jr-btn graycolor text-white refresh-btn" onClick={() => this.OnAssignNewAccount()} >Save</Button>
                                    <Button variant="contained" className=" jr-btn graycolor text-white refresh-btn" onClick={() => this.OnApplyIgnored()} >{this.state.IsIgnoredFilter ? "Revert" : "Ignore"}</Button>
                                    <Button variant="contained" className=" jr-btn graycolor text-white refresh-btn" onClick={() => this.OnAssignNBD()} >Assign NBD</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.loading ? <div className="dei-loader-box"><CircularProgress /></div> :
                        <div className="table-responsive-material">
                            <table className="table tablebox account-reconcilliation dei-txn-table uct-table">
                                <thead>
                                    <tr style={{ backgroundColor: this.state.ColorCode }}>
                                        {this.sortHeader('date', 'Date')}
                                        {this.sortHeader('transactionType', 'Type')}
                                        {this.sortHeader('num', 'Number')}
                                        {this.sortHeader('name', 'Name')}
                                        {this.sortHeader('amount', 'Amount', 'text-right')}
                                        {this.sortHeader('memoOrDescription', 'Memo/Description')}
                                        {this.sortHeader('internalNotes', 'Internal Notes')}
                                        {this.sortHeader('accountantComment', 'Questions and Comments')}
                                        {/* New Account # column removed; see COLUMN_COUNT. */}
                                        <th className="text-center dei-flag-col"><p className="table-th-title dei-flag-title">CPA</p></th>
                                        <th className="td-width-90 text-center">
                                            <label className="container101 header-check">
                                                <input className="second-check-box" type="checkbox" checked={!!this.state.SelectALL} onChange={(e) => this.SelectALL(e)} />
                                                <span className="checkmark101 white_border"></span>
                                            </label>
                                        </th>
                                        <th className="td-width-90 text-center"><img src="/vendors/WhiteCommnet.png" alt="comments" /></th>
                                        <th className="td-width-90 text-center"><img src="/vendors/Link-arrow_header.png" alt="link" /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.lst_GL.map((account, i) => (
                                        <React.Fragment key={i}>
                                            <tr className={`uct-group-tr ${account.isExpand ? "bg-active" : ""}`} onClick={() => this.onRowExpandCollapseClick(i)}>
                                                <td className="title-name" colSpan={COLUMN_COUNT}>
                                                    <div className="uct-group-header">
                                                        {account.isExpand ? <i className="zmdi zmdi-minus-circle-outline orange-minus-circle"></i> : <i className="zmdi zmdi-plus-circle-o"></i>}
                                                        <span className="account-text">{account.account}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            {account.isExpand && account.isBeginningAmount &&
                                                <tr className="uct-sum-tr">
                                                    <td colSpan="4" className="table-sub-title">Beginning Balance</td>
                                                    <td className="text-right">{numberWithCommas(account.beginningAmount)}</td>
                                                    <td colSpan={COLUMN_COUNT - 5}></td>
                                                </tr>}
                                            {account.isExpand && (account.data || []).map((item, j) => (
                                                <React.Fragment key={item.id}>
                                                    <tr className={`dei-clickable ${item.vendor1099 ? 'greenrow' : ''}`} onClick={() => this.onRowClick(i, j)}>
                                                        <td title={moment(item.date).format("MM/DD/YYYY")}>{moment(item.date).format("MM/DD/YYYY")}</td>
                                                        <td title={item.transactionType || ''}>{item.transactionType}</td>
                                                        <td title={item.num || ''}>{item.num}</td>
                                                        <td title={item.name || ''}>{item.name}</td>
                                                        <td className="text-right">{numberWithCommas(item.amount)}</td>
                                                        <td title={item.memoOrDescription || ''}>{item.memoOrDescription}</td>
                                                        <td title={item.internalNotes || ''}>{item.internalNotes}</td>
                                                        <td title={item.accountantComment || ''}>{item.accountantComment}</td>
                                                        <td className="text-center">{item.cpaReview ?
                                                            <FontTooltip id="tooltip-icon" title="CPA Review" placement="top-start">
                                                                <i className="zmdi zmdi-check"></i>
                                                            </FontTooltip>
                                                            : ''}</td>
                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                            <label className="container101">
                                                                <input
                                                                    className="second-check-box"
                                                                    type="checkbox"
                                                                    checked={!!(this.state.SelectALL || (selectedItem.length > 0 && selectedItem.indexOf(item.id) > -1))}
                                                                    onChange={(e) => this.onCheckboxClick(e, item)}
                                                                />
                                                                <span className="checkmark101"></span>
                                                            </label>
                                                        </td>
                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                            <div className="panel-commentCount">
                                                                <img src="/vendors/Vector Smart Object.png" alt="comments" className={item.commentCount === 0 ? "disableCommentsOpacity" : ""} onClick={(e) => { e.stopPropagation(); this.LoadComments(item); }}></img>
                                                                {item.unreviewCommentCount !== 0 && <span className="badge badge-pill badge-danger ng-star-inserted">{item.unreviewCommentCount}</span>}
                                                            </div>
                                                        </td>
                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}><img src="/vendors/Shape 1.png" alt="QBDlink" onClick={(e) => this.onLinkClick(e, i, j, item)}></img></td>
                                                    </tr>
                                                    {this.state.editIndex1 === i && this.state.editIndex === j &&
                                                        <TransactionEditRow
                                                            item={item}
                                                            rowKey={item.id}
                                                            colSpan={COLUMN_COUNT}
                                                            flags={EDIT_FLAGS}
                                                            accountOptions={this.state.DisplayAccounts}
                                                            onSave={(editData) => this.onRowSave(item, editData)}
                                                            onCancel={this.onRowCancel}
                                                        />}
                                                </React.Fragment>
                                            ))}
                                            {account.isExpand && (!account.data || account.data.length === 0) &&
                                                <tr>
                                                    <td className="text-center" colSpan={COLUMN_COUNT}>
                                                        No issues here! Keep up the good work!
                                                    </td>
                                                </tr>
                                            }
                                            {account.isExpand &&
                                                <tr className="uct-sum-tr">
                                                    <td colSpan="4" className="table-sub-title">Total for {account.account}</td>
                                                    <td className="text-right uct-total-amount">{account.totalAmount != null ? `$${numberWithCommas(account.totalAmount)}` : null}</td>
                                                    <td colSpan={COLUMN_COUNT - 5}></td>
                                                </tr>}
                                        </React.Fragment>
                                    ))}
                                    {(!this.state.loading && this.state.lst_GL.length == 0) &&
                                        <tr>
                                            <td className="text-center" colSpan={COLUMN_COUNT}>
                                                No issues here! Keep up the good work!
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            </div>
        );
    }

}


const mapStateToProps = (state) => {
    return {
        ledgers: state.ledgers,
        accounts: state.accounts.accountsData,
        CommonUpdate: state.ledgers.CommonUpdate,
        LEDGER_UPDATE: state.ledgers.LEDGER_UPDATE,
        UpdateDescription: state.ReportData.UpdateDescription,
        ReportReviewdHistory: state.ledgers.ReportReviewedHistory,
        BATCH_LEDGER_UPDATE: state.ledgers.BATCH_LEDGER_UPDATE,
        BATCH_NBD_UPDATE: state.ledgers.BATCH_NBD_UPDATE
    };
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GetUncategorizeData,
        Accounts,
        LedgerUpdate,
        MarkReportReview,
        MARK_IGNORED_DATA,
        Revert_Ignored_DATA,
        GetReportReviewedHistory,
        UpdateBatchNewAccount,
        UpdateBatchNeedsBetterDescription
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(UnCategorizeTransaction);